import React, { useEffect, useState } from 'react'
import { getStoreId, getStoreData } from '@/redux/app-selectors';
import { ToasterNotification } from '@/toaster/toasterNotification';
import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text } from '@chakra-ui/react'
import './index.scss';
import { uploadData } from 'aws-amplify/storage';

export default function UploadPreferredCSV({ isOpen, onClose }: { isOpen: boolean, onClose: () => void }) {
  const storeId = getStoreId()
  const storeData = getStoreData()
  const [isLoading, setIsLoading] = useState(false)
  const [isValidFile, setIsValidFile] = useState(true)
  const [error, setError] = useState('');
  
  const [file, setFile] = useState<File | null>(null)
  async function uploadPreferrdCSVInS3() {
    try {
      if (file) {
        setIsLoading(true)
        const name = encodeURIComponent(`${file?.name}`)
        await uploadData({
          path: `preferences/${storeId}/preferredDealers/${name}`,
          data: file,
          options: {
            bucket: "preferences",
            contentType: 'application/csv',
            metadata: { store_id: storeId, email: (storeData?.contact_email || ""),
            type: 'preferred',
          }
        }});

        ToasterNotification("success", "Preferred Dealers Uploaded Successfully")
        setIsLoading(false);
        setFile(null)
        onClose()
      }
    } catch (error) {
      console.log({ error });
      setIsLoading(false);
      setFile(null)
      onClose()

    }
  }

  useEffect(() => {
    if(file?.name && !['csv'].includes(file?.name?.split('.')?.pop() as string)){
      setIsValidFile(true);
      setError('Please upload .csv file only');
    } else if (file?.name && ['csv'].includes(file?.name?.split('.')?.pop() as string)) {
      setIsValidFile(false);
      setError('');
    }
  }, [file]);

  return <Modal isOpen={isOpen} onClose={onClose} isCentered={true}>
    <ModalOverlay className='confirmation-modal__overlay' />
    <ModalContent className='confirmation-modal'>
      <ModalHeader className='confirmation-modal__header'>
        Upload Preferred Dealers
        <button className='transfer-create-modal__close-btn' onClick={onClose}><img src='/images/ui/close.svg' /></button>
      </ModalHeader>
      <ModalBody className='confirmation-modal__body' padding="40px 38.5px">
        <input
          style={{ marginBottom: '10px' }}
          type="file"
          accept=".csv"
          onChange={(e) => {
            if (e.target.files)
              setFile(e.target.files[0]);
          }}
        />
         {error && <Text fontSize='xs' color='red'>{error}</Text>}
      </ModalBody>
      <ModalFooter className='confirmation-modal__footer'>
        <Button
          className='confirmation-modal__secondary-btn'
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          onClick={uploadPreferrdCSVInS3}
          isLoading={isLoading}
          isDisabled={isLoading || isValidFile}
          className='confirmation-modal__primary-btn'
        >
          Upload
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
}


